import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Stores which company the super_admin is currently viewing.
 * For all other roles, this store is ignored — their company_id
 * comes directly from the JWT token on every API call.
 */
export const useCompanyStore = create(
    persist(
        (set) => ({
            activeCompany: null,      // { id, name, ... } or null
            companies: [],            // full list loaded once on login

            setActiveCompany: (company) => set({ activeCompany: company }),
            setCompanies: (companies) => set({ companies }),
            clearCompany: () => set({ activeCompany: null, companies: [] }),
        }),
        { name: 'payroll-company' }
    )
);
